<template>
  <v-container>
    <v-layout row wrap>
      <v-flex>
        <list-header icon="event" title="Dostępne usługi" />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex mb-3>
        <filter-tab :tabs="categories" :active="selectedCategory" @change="categoryChange" />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex>
        <benefits :header="false" :inrow="3" :categories="selectedCategories" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { SettingValueType, sharedConfig } from '@witkac/kartamiejska-shared';

import store from '@/store/store';
import ListHeader from '@/components/ListHeader';
import Benefits from '@/components/benefits/Benefits';
import FilterTab from '@/components/FilterTab';

// @vuese
// Lista usług z filtrem
// @group Benefits
export default {
  components: { Benefits, FilterTab, ListHeader },
  data() {
    return {
      selectedCategories: undefined
    };
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch('settings/get', 'PUBLIC_CATEGORIES'),
      store.dispatch('categories/list'),
      loadBenefits(to)
    ])
      .then(() => next())
      .catch(err =>
        store.dispatch('notifyError', {
          title: 'Wystąpił błąd podczas pobierania listy usług.',
          messages: [error.message || error]
        })
      );
  },
  beforeRouteUpdate(to, from, next) {
    loadBenefits(to).then(() => next());
  },
  computed: {
    ...mapState({
      categories: state => [
        { id: -10, name: 'Wszystkie', to: { name: 'benefits_all' } },
        {
          id: -20,
          name: 'Wydarzenia',
          to: { name: 'benefits_events' }
        },
        ...state.categories.list.filter(item =>
          state.settings.PUBLIC_CATEGORIES.value.list.includes(item.id)
        )
      ],
      selectedCategory(state) {
        return this.categories.find(
          category => category.id === state.categories.id
        );
      }
    })
  },
  methods: {
    /**
     * @vuese
     * Zmiana adresu na podstawie wybranej kategorii
     * @index indeks wybranej kategorii
     */
    categoryChange(category) {
      if (this.selectedCategory.id !== category.id) {
        this.$store.commit('categories/setId', category.id);

        if (category.to) {
          return this.$router.push(category.to);
        }

        this.$router.push({
          name: 'benefits_category',
          params: { category: category.id }
        });
      }
    }
  }
};

/**
 * Załadowanie usług na podstawie kategorii do store
 *
 */
function loadBenefits(route) {
  const selectedCategory = route.params.category
    ? parseInt(route.params.category)
    : undefined;
  const event = route.meta.events || false;

  if (selectedCategory) {
    store.commit('categories/setId', selectedCategory);
  } else if (event) {
    // events
    store.commit('categories/setId', -20);
  } else {
    // all
    store.commit('categories/setId', -10);
  }
  return store
    .dispatch('benefits/userBenefits', {
      event,
      categories: selectedCategory ? [selectedCategory] : undefined,
      count: sharedConfig.onPage,
      order: 'start',
      desc: true
    })
    .catch(err =>
      store.dispatch('notifyError', {
        title: 'Wystąpił błąd podczas pobierania listy usług.',
        messages: [error.message || error]
      })
    );
}
</script>
<style>
.v-card__title div {
  max-width: 100%;
  overflow-x: hidden;
}
</style>